import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Initialize Cloudscape plugins before anything else
if (typeof window !== 'undefined') {
  window.awsuiPlugins = window.awsuiPlugins || {};
  window.awsuiPlugins.all = window.awsuiPlugins.all || [];
}

// Suppress ResizeObserver loop warnings (harmless, caused by Cloudscape components)
// This must be done BEFORE any other code runs

// Method 1: Override the global error handler (catches webpack overlay errors)
const originalOnError = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  if (
    (typeof message === 'string' && message.includes('ResizeObserver loop')) ||
    (error && error.message && error.message.includes('ResizeObserver loop'))
  ) {
    return true; // Suppress the error
  }
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error);
  }
  return false;
};

// Method 2: Suppress console.error
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('ResizeObserver loop') || 
     args[0].includes('ResizeObserver loop completed with undelivered notifications'))
  ) {
    return;
  }
  originalConsoleError.call(console, ...args);
};

// Method 3: Suppress window error events
window.addEventListener('error', (event) => {
  if (
    event.message &&
    (event.message.includes('ResizeObserver loop') ||
     event.message.includes('ResizeObserver loop completed with undelivered notifications'))
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
}, true); // Use capture phase to catch it early

// Method 4: Catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason &&
    event.reason.message &&
    (event.reason.message.includes('ResizeObserver loop') ||
     event.reason.message.includes('ResizeObserver loop completed with undelivered notifications'))
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);